__webpack_require__.p = "/wp-content/themes/museum-lindwurm.ch/dist/";